import styled, { css } from 'styled-components';
import { Alert } from 'react-bootstrap';
import { FnAlertTypes, VARIANT_COLORS } from './constants';

export const AlertStyled = styled(Alert)<{ type: FnAlertTypes }>`
  padding: 0 16px 0 20px !important;
  margin: 0;
  min-width: 600px;
  height: 50px !important;
  border-radius: 5px;
  display: flex;
  align-items: center !important;
  font-size: 14px;
  margin-bottom: 0 !important;

  ${(props) =>
    props &&
    css`
      color: ${VARIANT_COLORS[props.type].color};
      background-color: ${VARIANT_COLORS[props.type].backgroundColor};
    `};
`;

export const SpanNote = styled.span`
  margin: 0 10px 0 15px;
  font-weight: 600;
`;
